import { createContext } from 'react';

export const HoverContext = createContext( { xVal: undefined, yVal: undefined, d: undefined } );
